import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceCatalogServices } from '../services/service-catalog.service';

export const useDeleteServiceCatalog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: serviceCatalogServices.softDeleteServiceCatalog,
    onSuccess: () => {
      queryClient.invalidateQueries(['service-catalog']);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete service catalog entry');
    },
  });
};
